module.exports = __webpack_public_path__ + "static/llama-bg-02-m-bb95351e32ad41684da747169ede47c0.png";